import RadioButtonGroup from "Components/RadioButtonGroup/RadioButtonGroup";
import { useEffect, useState } from "react";
import "./ChallengeBilling.scss";

import { useAuth } from "@clerk/clerk-react";
import { Check, CreditCard, Wallet } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import add from "../../Assets/Images/addon.svg";
import bitcoin from "../../Assets/Images/bitcoin.svg";
import drawdown from "../../Assets/Images/drawdown.svg";
import ea from "../../Assets/Images/ea.svg";
import news from "../../Assets/Images/news.svg";
import payout from "../../Assets/Images/payout.svg";
import profit from "../../Assets/Images/profit.svg";
import usd from "../../Assets/Images/usd.png";
import {
  createDraft,
  getAddons,
} from "../../Redux/ChallengeSetup/ChallengeSetupAction";
import {
  clearAllStatesses,
  createInvoice,
  getInvoice,
  getInvoiceQr,
} from "../../Redux/CryptoChill/CryptoChillAction";

import { Skeleton } from "Components/ui/skeleton";
import useCountdown from "hooks/use-countDown";
import { io } from "socket.io-client";
function BillingInfo({
  challengeType,
  paymentMethod,
  setPaymentMethod,
  setSelectedAddon,
  selectedAddon,
  currency,
  setCurrency,
  paymentProvider,
  setPaymentProvider,
  all,
}) {
  const dispatch = useDispatch();

  const { addons, addonsLoading } = useSelector(
    (state) => state.ChallengeSetupReducer
  );

  const { user } = useSelector((state) => state.ProfileReducer);

  const [ip, setIp] = useState("");

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => setIp(data.ip))
      .catch((error) => console.error("Error fetching IP address:", error));
  }, []);
  useEffect(() => {
    if (challengeType) {
      dispatch(getAddons(challengeType));
    }
  }, [challengeType]);

  return (
    <>
      <div>
        <div className=" text-2xl  mb-6">Select your addons</div>
        <div className="grid grid-cols-2 gap-4 w-full">
          {addonsLoading
            ? Array(5)
                ?.fill(0)
                ?.map((item, index) => (
                  <Skeleton className="border-2 border-border-darkNew cursor-pointer flex-1 p-3 rounded-xl h-28 bg-background-secondary " />
                ))
            : addons?.map((addon) => {
                return (
                  <div
                    className={`${"border-2 border-border-darkNew cursor-pointer flex-1 px-4 py-4 rounded-xl flex flex-col gap-1"}   ${
                      selectedAddon.includes(addon) &&
                      "border-primary bg-primary-foreground"
                    }`}
                    onClick={() =>
                      setSelectedAddon(
                        selectedAddon.includes(addon)
                          ? selectedAddon.filter((item) => item !== addon)
                          : [...selectedAddon, addon]
                      )
                    }
                  >
                    <div className="flex items-start justify-between">
                      <div>
                        <div className="h-5">
                          <img
                            src={
                              addon?.name === "Extra Drawdown"
                                ? drawdown
                                : addon?.name == "Profit Share 90%"
                                ? profit
                                : addon?.name == "Faster Payouts"
                                ? payout
                                : addon?.name == "News Trading"
                                ? news
                                : addon?.name == "EA Trading "
                                ? ea
                                : add
                            }
                            alt="drawdown"
                            className={
                              addon?.name === "Extra Drawdown" ? "h-3" : "h-4"
                            }
                          />
                        </div>

                        <div className="text-lg font-N_Bold mb-1 ">
                          {addon?.name}
                        </div>
                        <div className="text-white-opacity text-xs mb-2">
                          {addon?.description ||
                            "Enjoy addons that will help you trade better and faster."}
                        </div>
                      </div>

                      {selectedAddon.includes(addon) ? (
                        <div className="text-primary border-2 border-primary rounded-full p-[0.1rem] text-xs  flex justify-center bg-primary">
                          <Check
                            color="white"
                            className="w-3 h-3 aspect-square"
                          />
                        </div>
                      ) : (
                        <div className="text-primary border-2 border-border-darkNew rounded-full p-1 text-xs  flex justify-center  w-5 h-5 aspect-square"></div>
                      )}
                    </div>
                  </div>
                );
              })}
        </div>
      </div>
      <div>
        <div className="mb-6">
          <div className=" text-2xl ">Billing Info</div>
          <div className="text-white-opacity text-sm">
            Before you start trading for us, we need to know some basic
            information about you.
          </div>
        </div>
        <RadioButtonGroup
          noIcon
          grid={2}
          uniqueName={"paymentMethod"}
          data={[
            {
              label: (
                <div className="flex flex-col gap-2 items-start text-white">
                  <CreditCard />
                  <div>Credit Card</div>
                </div>
              ),
              value: "CC",
            },
            {
              label: (
                <div className="flex flex-col gap-2 items-start text-white">
                  <img src={bitcoin} alt="USD" className="w-6" />
                  <div>Crypto</div>
                </div>
              ),
              value: "Crypto",
              disabled: false,
            },
            {
              label: (
                <div className="flex flex-col gap-2 items-start text-white">
                  <Wallet className="w-6" />
                  <div>
                    Wallet (
                    {user?.Wallet?.balance
                      ? user?.Wallet?.balance?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })
                      : "$0.00"}
                    )
                  </div>
                </div>
              ),
              value: "wallet",
              disabled: all ? true : false,
            },
          ]}
          checked={paymentMethod}
          setChecked={setPaymentMethod}
        />
      </div>
      {paymentMethod == "CC" && (
        <div>
          <div className="mb-6">
            <div className=" text-lg  mb-6">Choose your payment method</div>
          </div>
          <RadioButtonGroup
            grid={2}
            uniqueName={"paymentProvider"}
            data={[
              {
                label: (
                  <div className="flex gap-2 items-center">
                    <div>Stripe</div>
                  </div>
                ),
                value: "STRIPE",
              },

              // {
              //   label: (
              //     <div className="flex gap-2 items-center">
              //       <div>Neteller</div>
              //     </div>
              //   ),
              //   value: "NETELLER",
              // },
              // {
              //   label: (
              //     <div className="flex gap-2 items-center">
              //       <div>Skrill</div>
              //     </div>
              //   ),
              //   value: "Skrill",
              // },
            ]}
            checked={paymentProvider}
            setChecked={setPaymentProvider}
          />
        </div>
      )}
      <div>
        <div className=" text-lg  mb-6">Payment Currency</div>
        <RadioButtonGroup
          grid={2}
          uniqueName={"paymentInfo"}
          data={[
            {
              label: (
                <div className="flex gap-2 items-center">
                  <img src={usd} alt="USD" className="w-6" />
                  <div>USD</div>
                </div>
              ),
              value: "USD",
            },
          ]}
          checked={currency}
          setChecked={setCurrency}
        />
      </div>
    </>
  );
}

export default BillingInfo;

const SocketIo = io(process.env.REACT_APP_BACKEND_URL + "/cryptochill", {
  reconnection: true,
  reconnectionDelay: 100000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 99999,
});
